function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "30.401,52.577 31.307,59.099 39.272,62.753 41.485,62.102 43.703,67.192 48.008,67.582  51.397,63.67 53.486,66.274 52.837,72.147 66.535,80.886 72.013,81.54 78.536,89.366 79.713,95.369 77.23,98.369 79.188,103.199  118.063,140.503 132.548,164.252 134.111,169.86 147.292,185.127 157.202,197.134 161.512,200 165.163,200 165.554,197.781  163.987,182.519 168.947,181.21 169.599,174.428 168.297,172.084 162.427,171.166 156.293,158.124 151.334,141.557 151.074,133.73  141.81,119.774 132.158,122.641 126.027,109.984 119.893,99.935 114.935,96.673 112.46,88.718 112.719,60.798 105.679,52.968  103.846,44.228 88.325,38.62 80.362,4.571 70.193,0 66.535,2.61 67.444,9.661 40.573,32.492 38.354,28.576 35.616,36.397  31.052,43.182 "
});

var Svg25 = function Svg25(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SIN",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg25, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/25.37d03483.svg";
export { ForwardRef as ReactComponent };